import {Avatar, Button, Image} from 'antd'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useCallback, useContext, useMemo, useState,} from 'react'
import {BiSolidEdit, BiTrash} from 'react-icons/bi'
import {useLocation} from 'react-router-dom'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {bindQueryParams,} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {SectionTemplate} from "../../Workspace";
import {useRouterSearchParam} from "../../../../modules/navigation/useOnLocationChange";
import {useCourseForm} from "../../../AppLocals/Course/CourseClass/useCourseForm";
import classNames from "classnames";
import {EntityPaginationMeta} from "../../../AppLocals/EntityList";
import {ShopContainerContext} from "./ShopContainer";
import {shop_fetchItems_Api} from "../../../../apis";
import CRUD from "../../../Shared/enums/CRUD";
import {StudentActionTypes} from "../../../AppLocals/Course";
import {ImagePlaceholder} from "../../../../conts/imageBase64";
import {ShoppingIconSvg} from "../../../../components/Svgs/ShoppingIconSvg";
import {useShopForm} from "../../../AppLocals/Shop/functions/useShopForm";

const renderGridMeta = (props) =>
    (
        <LayoutContext.Consumer>
            {({isLg}) => (
                <div className={classNames(isLg ? 'col-span-2' : 'col-span-1')}>
                    <EntityPaginationMeta
                        {...props}
                        style={{position: 'inherit'}}
                    />
                </div>
            )}
        </LayoutContext.Consumer>
    )

const Shops = ({
                   organization,
                   owner_id,
                   owner_type,
                   filter_actions = {
                       sortBy: 'sort-by',
                       keyword: 'keyword',
                       status: 'shop-status',
                   },
               }) => {
    const t = useTranslate()

    const history = useHistory()

    const location = useLocation()

    const {isSm, isLg} = useContext(LayoutContext)

    const [refreshKey, setRefreshKey] = useState()

    const {onChangeSearchParams} = useRouterSearchParam({})
    const {onSelectShopContainerRoute, setCurrentShopId} = useContext(ShopContainerContext)

    const sortBy = useRouteSearchParam(filter_actions.sortBy)
    const status = useRouteSearchParam(filter_actions.status)

    const {
        modal,
        handleAction,
        onCancel,
    } = useShopForm({organization})

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'edit',
                        key: CRUD.UPDATE,
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: CRUD.DELETE,
                    },
                ].filter((e) => item),
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            refreshKey,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, refreshKey, location.state]
    )

    const [pager_widget] = usePaginationHelper({
        filter_params: {
            owner_id,
            owner_type
        },
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({
                status,
            })
            onSortChange(sortBy)
        },
        pagerInfo: {
            RenderEntity: React.Fragment,
            renderItem: renderShop({
                isLg: isLg,
                translate: t,
                onSelectShopContainerRoute,
                renderContextMenu
            }),
            PaginationMeta: NullAsDefault,
            apiInfo: shop_fetchItems_Api,
            query: bindQueryParams([{id: owner_id}, {type: owner_type}]),
            renderWrap: (child) => (
                <div className="mt-2 flex flex-col divide-y divide-gray-200 list-item-workspace">
                    {child}
                </div>
            ),
        },
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        isToggleDefault: false,
        query_params: filter_actions,
        renderFilter: NullAsDefault,
        AdvancedFilter: NullAsDefault,
        dependencies: [owner_id, owner_type],
        withKey: createPagerKey(refresh_deps),
    })


    return (
        <div className="flex flex-col gap-3">
            <div className="flex flex-col md:flex-row md:items-center gap-x-6 gap-y-3">
                <div className="flex flex-col flex-1">
                    <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                        {t('shop management')}
                    </h2>
                    <div className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                    <div className="mt-1 text-sm text-color-300 tracking-wider">
                        {t('shop management description')}
                    </div>
                </div>
            </div>
            {pager_widget}
            {modal}
            <div className="h-16"/>
        </div>
    )
}


const renderShop = ({onSelectShopContainerRoute, translate: t, isLg, renderContextMenu = NullAsDefault} = {}) => (item, index) => {

    const {
        avatar, photos = [],
        description, status,
    } = item ?? {}

    return (
        <div key={index} className="p-4 flex flex-col md:flex-row gap-2 md:gap-3 custom-item-render list-item relative">

            <div className="relative">
                <Image
                    preview={false}
                    src={photos[0]?.path || ImagePlaceholder}
                    fallback={ImagePlaceholder}
                    style={{ width: isLg ? 180 : '100%', height: 180}}
                    className="rounded-xl object-cover bg-no-repeat"
                    wrapperStyle={{ width: isLg ? 180 : '100%' }}
                    wrapperClassName="rounded-xl"
                />
                <Avatar
                    size={60}
                    src={avatar}
                    icon={<ShoppingIconSvg size={30} className="text-secondary-400"/>}
                    style={{ bottom: 10, right: 10, border: '4px solid #fff' }}
                    className="flex flex-center bg-indigo-50 rounded-xl absolute"
                />
            </div>
            <div className="flex flex-col flex-1 relative">
                <h2
                    onClick={() => {onSelectShopContainerRoute({current_shop_id: item.id})}}
                    className="font-bold text-base text-color-000 hover:text-primary tracking-wide cursor-pointer">
                    {item.title}
                </h2>
                <div className="flex items-center gap-1 tracking-wider">
                    <span className="text-color-400">
                        {`${t('status')}: `}
                    </span>
                    <span className={classNames("font-medium tracking-wide italic", status === 1 ? 'text-green-600' : 'text-blue-500')}>
                        {status === 1 ? t('active') : t('pending')}
                    </span>
                </div>
                <div className="my-1 border-b border-color-50"/>
                <div className="mt-2 text-color-300 tracking-wider max-lines-3">
                    {description}
                </div>
                {(_.isFunction(renderContextMenu) && !isLg)&& (
                    <div className="absolute right-0 top-20 contextIcon">
                        {renderContextMenu(item)}
                    </div>
                )}
            </div>
            {(_.isFunction(renderContextMenu) && isLg) && (
                <div className="absolute right-8 top-8 contextIcon">
                    {renderContextMenu(item)}
                </div>
            )}
        </div>
    )
}


export default Shops
